import { render, staticRenderFns } from "./KollelLogDetails.vue?vue&type=template&id=97e3fe4a&"
import script from "./KollelLogDetails.vue?vue&type=script&lang=js&"
export * from "./KollelLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports